import React, { FC } from 'react';
import { FormFragment } from '../../types/graphqlTypes';
import { Section } from '../Section';
import { BlockManagementReportAnIssue } from './BlockManagementReportAnIssue';
import { BlockManagementTenantRegistration } from './BlockManagementTenantRegistration';
import { UnsubscribeForm } from './UnsubscribeForm';
import { LeaseExtensionQuote } from './LeaseExtensionQuote';
import { PropertyManagementReview } from './PropertyManagementReview';

// JSX

export const Form: FC<Omit<FormFragment, '__typename'>> = ({ formType }) => (
  <Section contained narrow>
    {formType === 'Block management Report an issue' && <BlockManagementReportAnIssue />}
    {formType === 'Tenancy registration' && <BlockManagementTenantRegistration />}
    {formType === 'Unsubscribe' && <UnsubscribeForm />}
    {formType === 'Lease extension quote' && <LeaseExtensionQuote />}
    {formType === 'Property management review' && <PropertyManagementReview />}
  </Section>
);
